import React from "react";
import { Row, Col, Button, Form, Input } from "antd";

const FormItem = Form.Item;

const SignUp = () => {
    const onFinish = () => {};

    return (
        <div className="gx-app-login-wrap">
            <div className="gx-app-login-container">
                <Row gutter={[0, 25]} type="flex">
                    <Col span={24} align="middle" justify="center">
                        <div className="gx-app-logo">
                            <h1>App Logo</h1>
                        </div>
                    </Col>
                    <Col span={24}>
                        <div className="gx-app-login-main-content">
                            <div className="gx-app-logo-content">
                                <div className="gx-app-logo-content-bg">
                                    <img
                                        src={
                                            "https://via.placeholder.com/272x395"
                                        }
                                        alt="Neature"
                                    />
                                </div>
                            </div>

                            <div className="gx-app-login-content">
                                <Form
                                    initialValues={{ remember: true }}
                                    name="basic"
                                    onFinish={onFinish}
                                    className="gx-signin-form gx-form-row0"
                                >
                                    <Form.Item>
                                        <h2>Sign Up</h2>
                                    </Form.Item>
                                    <FormItem
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please input your username!",
                                            },
                                        ]}
                                        name="Username"
                                    >
                                        <Input placeholder="Username" />
                                    </FormItem>

                                    <FormItem
                                        name="email"
                                        rules={[
                                            {
                                                required: true,
                                                type: "email",
                                                message:
                                                    "The input is not valid E-mail!",
                                            },
                                        ]}
                                    >
                                        <Input placeholder="Email" />
                                    </FormItem>
                                    <FormItem
                                        name="password"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please input your Password!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            type="password"
                                            placeholder="Password"
                                        />
                                    </FormItem>
                                    <FormItem>
                                        <Button
                                            type="primary"
                                            className="gx-mb-0"
                                            htmlType="submit"
                                        >
                                            Sign Up
                                        </Button>
                                    </FormItem>
                                </Form>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default SignUp;
